import React from "react";
import "../styles/experience.css";
import { pageIds } from "../utils/contants";

const experienceData = [
  {
    title: "Node.js Backend Developer",
    period: "Dec 2025 – Sep 2026",
    company: "Satya Kabir E-Solutions Pvt. Ltd.",
    location: "Bhopal, India",
    bullets: [
      "Built production backend for SparkSurge (live on Play Store) – city-wise car wash booking with provider management, vehicle categories, slot booking, and order tracking APIs.",
      "Built production backend for ConstructionOne (live on Play Store) – multi-role construction e-commerce with User, Vendor, and Admin apps; handling real transactions.",
      "Designed MongoDB schemas optimized for production scale; implemented JWT auth and RBAC across all roles.",
      "Integrated third-party services including payment gateways and file upload pipelines for both applications.",
    ],
  },
  {
    title: "MERN Stack Developer Intern",
    period: "Sep 2025 – Dec 2025",
    company: "Codec Technologies Pvt. Ltd.",
    location: "Remote",
    bullets: [
      "Developed full-stack features for internal management tools handling large-scale MongoDB datasets.",
      "Implemented Redux Toolkit for state management and Mongoose middleware for schema-level data validation.",
    ],
  },
  {
    title: "Junior Software Developer Intern",
    period: "Dec 2024 – Mar 2025",
    company: "LeopardRuns Innovation & Technology",
    location: "Bhopal, India",
    bullets: [
      "Built responsive React.js UI components with Tailwind CSS; integrated RESTful APIs via Axios.",
      "Participated in code reviews and debugging sessions to improve application stability.",
    ],
  },
];

export const Experience = () => {
  return (
    <section className="experience-section" id={pageIds.experience}>
      <div className="experience-header">
        <p className="section-tag">Journey</p>
        <h1>Professional Experience</h1>
      </div>

      <div className="experience-timeline">
        {experienceData.map((exp) => (
          <div className="experience-card" key={`${exp.title}-${exp.period}`}>
            <div className="experience-dot" aria-hidden="true" />
            <div className="experience-content">
              <div className="experience-topline">
                <h2>{exp.title}</h2>
                <span>{exp.period}</span>
              </div>

              <div className="experience-company">
                <strong>{exp.company}</strong>
                <span>{exp.location}</span>
              </div>

              <ul>
                {exp.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
